// React
import React, { Component } from "react";
import ReactDOM from "react-dom";

// Styles
import './messagebox.css';

class MessageBox extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {
            hide : false
        };
            
        this.hideToast = this.hideToast.bind(this);
            
    }


/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all parameters and the corresponding chart
    componentDidMount() {

        //console.log('MessageBox.componentDidMount()');

    }

/**********************************************************
 *  Helper Functions
 **********************************************************/

    // Hide the toast
    hideToast() {

        ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(this).parentNode);

    }

    getIconClass(type) {

        // Determine the icon class
        var iconClass = ' icon-cross2 ';

        if(type === 'success')
            iconClass = ' icon-checkmark3 ';
        else if(type === '' || type === 'info' || type === 'warning')
            iconClass = ' icon-power2 ';

        return iconClass;

    }

/**********************************************************
 *  Render
 **********************************************************/

    render() {

        //console.log('MessageBox.render()');

        // Hide message box when message is null
        if(this.props.message === null)
            return null

        const iconClass = this.getIconClass(this.props.message.type);
        
        // Show close icon if its a toast
        var closeIcon = this.props.message.type.indexOf('toast') > -1 ? (<div className="message-close"><i className="icon-cross2" onClick={this.hideToast}></i></div>) : null;

        // Determine whether or not to hide toast
        var hide = this.state.hide ? ' hide-toast' : '';

        return (

            <div className={"message-box " + this.props.message.type + hide} >
                
                <div className={"message-left"}>
                    <i className={iconClass + this.props.message.type}></i>
                </div>

                <div className="message-right">
                    <div className="message-title">
                        {this.props.message.title}
                    </div>
                    <div className="message-details">
                        {this.props.message.details}
                    </div>
                </div>

                {closeIcon}
            </div>

        );
    }

}

export default MessageBox;





// WEBPACK FOOTER //
// ./src/Components/MessageBox/MessageBox.js